import React, {ChangeEvent, useCallback, useEffect, useState} from "react";
import {Input, InputProps} from "antd";
import {debounce} from "underscore";

export interface DebounceInputProps extends InputProps {
    debounceTimeout?: number;
}

const DebounceInput = ({ debounceTimeout, value, onChange, ...props }: DebounceInputProps) => {
    const [interimValue, setInterimValue] = useState(value);
    const [changeEvent, setChangeEvent] = useState<ChangeEvent<HTMLInputElement>>();

    useEffect(() => {
        if(value !== interimValue){
            setInterimValue(value);
        }
    }, [value]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceValue = useCallback(
        debounce(
            (event) => {
                if(onChange) onChange(event);
            }, debounceTimeout ? debounceTimeout : 500)
        , []);

    return (
        <Input
            {...props}
            value={interimValue}
            onChange={(event) => {
                setInterimValue(event.target.value);
                setChangeEvent(event);
                debounceValue(event);
            }}
            onPressEnter={() => {
                if(onChange && changeEvent) onChange(changeEvent);
            }}
        />
    );
}

export default DebounceInput;